import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guard/auth.guard';
import { GuestGuard } from '@core/guard/guest.guard';
import { LayoutComponent } from '@presentation/templates/layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    loadChildren: () =>
      import('@presentation/pages/admin/admin.routes').then(
        (m) => m.AdminRoutes,
      ),
  },
  {
    path: 'auth',
    canActivate: [GuestGuard],
    loadChildren: () =>
      import('@presentation/pages/auth/auth.routes').then((m) => m.AuthRoutes),
  },
  {
    path: 'docs',
    loadChildren: () =>
      import('@presentation/pages/documentation/documentation.routes').then(
        (m) => m.DocumentationRoutes,
      ),
  },
  {
    path: 'manual',
    loadChildren: () =>
      import('@presentation/pages/manual/manual.routes').then(
        (m) => m.ManualRoutes,
      ),
  },
  { path: 'documentacion', redirectTo: 'docs' },
  { path: 'documentation', redirectTo: 'docs' },
  {
    path: 'error',
    loadChildren: () =>
      import('@presentation/pages/error/error.routes').then(
        (m) => m.ErrorRoutes,
      ),
  },
  { path: '**', redirectTo: 'error/404' },
];
